// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdditionalCostConfirmationModal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7019607843);
  backdrop-filter: blur(3px);
  z-index: 1;
}
.AdditionalCostConfirmationModal .Content {
  display: flex;
  flex-direction: column;
  padding: 1rem 1.5rem 1.5rem 1.5rem;
  border-radius: 0.75rem;
  align-items: flex-start;
  background: var(--Foreground);
  min-height: 20rem;
  color: var(--TextColor);
}
.AdditionalCostConfirmationModal .Content .HeaderClose {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  height: 3rem;
}
.AdditionalCostConfirmationModal .Content .HeaderClose .ModalHeader {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--AccentColor);
}
.AdditionalCostConfirmationModal .Content .HeaderClose svg {
  cursor: pointer;
}
.AdditionalCostConfirmationModal .Content .HeaderClose svg path {
  fill: var(--AccentColor);
}
.AdditionalCostConfirmationModal .Content .HeaderClose svg:hover {
  transform: rotate(90deg);
  transition: all 0.3s ease;
}
.AdditionalCostConfirmationModal .Content .Hint {
  font-size: 0.875rem;
  width: 100%;
}
.AdditionalCostConfirmationModal .Content .Details {
  width: 100%;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.5rem;
  margin: 1rem 0;
}
.AdditionalCostConfirmationModal .Content .Details .Breakdown {
  margin: 0.5rem 0;
  width: 100%;
  padding: 0.5rem 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  border-radius: 0.75rem;
  border: 0.0625rem solid #9B9B9B;
}
.AdditionalCostConfirmationModal .Content .Details .Breakdown div {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.AdditionalCostConfirmationModal .Content .Details .Breakdown .Total {
  padding-top: 0.75rem;
  border-top: 0.125rem solid #9B9B9B;
  font-weight: 700;
}
.AdditionalCostConfirmationModal .Content label {
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 0.375rem;
  font-size: 0.75rem;
  margin-bottom: 1.5rem;
}
.AdditionalCostConfirmationModal .Content label input {
  cursor: pointer;
  height: 0.875rem;
  width: 0.875rem;
  accent-color: var(--AccentColor);
}
.AdditionalCostConfirmationModal .Content label span {
  cursor: pointer;
  text-wrap: pretty;
}
.AdditionalCostConfirmationModal .Content .ButtonContainer {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.5rem;
}
.AdditionalCostConfirmationModal .Content .ButtonContainer button {
  flex: 1 1;
  height: 2.5rem;
  border-radius: 0.5rem;
  background: var(--AccentColor);
  color: #ffffff;
  opacity: 0.8;
  transition: all 0.3s ease-in-out;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.AdditionalCostConfirmationModal .Content .ButtonContainer .Reject {
  background: var(--Invitation);
  color: var(--TextColor);
}
.AdditionalCostConfirmationModal .Content .ButtonContainer button:hover {
  opacity: 1;
  transition: all 0.3s ease-in-out;
}
.AdditionalCostConfirmationModal .Content .AddPaymentMet {
  display: flex;
  margin-top: 1rem;
}
.AdditionalCostConfirmationModal .Content .AddPaymentMet .AddPaymentGateway {
  width: 16.5rem;
  height: 10rem;
  border: 0.0625rem solid var(--Stroke);
  border-radius: 0.625rem;
  padding: 0.625rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 1.25rem;
  cursor: pointer;
}
.AdditionalCostConfirmationModal .Content .AddPaymentMet .AddPaymentGateway .WalletPayAmt {
  color: var(--TextColor);
  font-size: 1rem;
  font-weight: 600;
}
.AdditionalCostConfirmationModal .Content .AddPaymentMet .AddPaymentGateway .PayViaWallet {
  color: var(--AccentColor);
  font-size: 1rem;
  font-weight: 700;
}
.AdditionalCostConfirmationModal .Content .AddPaymentMet .AddPayWallet {
  width: 16.5rem;
  height: 10rem;
  margin-left: 0.5rem;
  border: 0.0625rem solid var(--Stroke);
  border-radius: 0.625rem;
  padding: 0.625rem;
  display: flex;
  cursor: pointer;
  align-items: center;
  flex-direction: column;
  gap: 1.25rem;
}
.AdditionalCostConfirmationModal .Content .AddPaymentMet .AddPayWallet .WalletPayAmt {
  color: var(--TextColor);
  font-size: 1rem;
  font-weight: 600;
}
.AdditionalCostConfirmationModal .Content .AddPaymentMet .AddPayWallet .PayViaWallet {
  color: var(--AccentColor);
  font-size: 1rem;
  font-weight: 700;
}
.AdditionalCostConfirmationModal .Content .AddPaymentMet .PaymentLoading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.062745098);
  backdrop-filter: blur(3px);
}`, "",{"version":3,"sources":["webpack://./src/Components/AdditionalCost/AdditionalCostConfirmationModal.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uCAAA;EACA,0BAAA;EACA,UAAA;AACF;AAAE;EACE,aAAA;EACA,sBAAA;EACA,kCAAA;EACA,sBAAA;EACA,uBAAA;EACA,6BAAA;EAEA,iBAAA;EACA,uBAAA;AACJ;AAAI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,YAAA;AAEN;AADM;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;AAGR;AADM;EACE,eAAA;AAGR;AAFQ;EACE,wBAAA;AAIV;AADM;EACE,wBAAA;EACA,yBAAA;AAGR;AAAI;EACE,mBAAA;EACA,WAAA;AAEN;AAAI;EACE,WAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,cAAA;AAEN;AADM;EACE,gBAAA;EACA,WAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,sBAAA;EACA,+BAAA;AAGR;AAFQ;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAIV;AAFQ;EACE,oBAAA;EACA,kCAAA;EACA,gBAAA;AAIV;AAAI;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,qBAAA;AAEN;AADM;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;AAGR;AADM;EACE,eAAA;EACA,iBAAA;AAGR;AAAI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AAEN;AADM;EACE,SAAA;EACA,cAAA;EACA,qBAAA;EACA,8BAAA;EACA,cAAA;EACA,YAAA;EACA,gCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAGR;AADM;EACE,6BAAA;EACA,uBAAA;AAGR;AADM;EACE,UAAA;EACA,gCAAA;AAGR;AAAI;EACE,aAAA;EACA,gBAAA;AAEN;AAEM;EACI,cAAA;EACF,aAAA;EACA,qCAAA;EACA,uBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;AAAR;AACQ;EACE,uBAAA;EACA,eAAA;EACA,gBAAA;AACV;AACQ;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;AACV;AAEM;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,qCAAA;EACA,uBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EAEA,mBAAA;EACA,sBAAA;EACA,YAAA;AADR;AAEQ;EACE,uBAAA;EACA,eAAA;EACA,gBAAA;AAAV;AAEQ;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;AAAV;AAGM;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,sCAAA;EACA,0BAAA;AADR","sourcesContent":[".AdditionalCostConfirmationModal{\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #000000b3;\n  backdrop-filter: blur(3px);\n  z-index: 1;\n  .Content{\n    display: flex;\n    flex-direction: column;\n    padding: 1rem 1.5rem 1.5rem 1.5rem;\n    border-radius: 0.75rem;\n    align-items: flex-start;\n    background: var(--Foreground);\n    // width: 32rem;\n    min-height: 20rem;\n    color: var(--TextColor);\n    .HeaderClose{\n      width: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 1rem;\n      height: 3rem;\n      .ModalHeader{\n        font-size: 1.5rem;\n        font-weight: 700;\n        color: var(--AccentColor);\n      }\n      svg{\n        cursor: pointer;\n        path{\n          fill: var(--AccentColor);\n        }\n      }\n      svg:hover{\n        transform: rotate(90deg);\n        transition: all 0.3s ease;\n      }\n    }\n    .Hint{\n      font-size: 0.875rem;\n      width: 100%;\n    }\n    .Details{\n      width: 100%;\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      gap: 0.5rem;\n      margin: 1rem 0;\n      .Breakdown{\n        margin: 0.5rem 0;\n        width: 100%;\n        padding: 0.5rem 0.75rem;\n        display: flex;\n        flex-direction: column;\n        gap: 0.75rem;\n        border-radius: 0.75rem;\n        border: 0.0625rem solid #9B9B9B;\n        div{\n          display: flex;\n          align-items: center;\n          justify-content: space-between;\n        }\n        .Total {\n          padding-top: 0.75rem;\n          border-top: 0.125rem solid #9B9B9B;\n          font-weight: 700;\n        }\n      }\n    }\n    label{\n      width: 100%;\n      display: flex;\n      align-items: flex-start;\n      gap: 0.375rem;\n      font-size: 0.75rem;\n      margin-bottom: 1.5rem;\n      input{\n        cursor: pointer;\n        height: 0.875rem;\n        width: 0.875rem;\n        accent-color: var(--AccentColor);\n      }\n      span{\n        cursor: pointer;\n        text-wrap: pretty;\n      }\n    }\n    .ButtonContainer{\n      width: 100%;\n      display: flex;\n      align-items: center;\n      flex-wrap: wrap;\n      gap: 1.5rem;\n      button{\n        flex: 1;\n        height: 2.5rem;\n        border-radius: 0.5rem;\n        background: var(--AccentColor);\n        color: #ffffff;\n        opacity: 0.8;\n        transition: all 0.3s ease-in-out;\n        font-size: 0.875rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n      .Reject{\n        background: var(--Invitation);\n        color: var(--TextColor);\n      }\n      button:hover{\n        opacity: 1;\n        transition: all 0.3s ease-in-out;\n      }\n    }\n    .AddPaymentMet{\n      display: flex;\n      margin-top: 1rem;\n      // background: gray;\n      // padding: 0.5rem;\n      // background-color: red;\n      .AddPaymentGateway {\n          width: 16.5rem;\n        height: 10rem;\n        border: 0.0625rem solid var(--Stroke);\n        border-radius: 0.625rem;\n        padding: 0.625rem;\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n        gap: 1.25rem;\n        cursor: pointer;\n        .WalletPayAmt {\n          color: var(--TextColor);\n          font-size: 1rem;\n          font-weight: 600;\n        }\n        .PayViaWallet {\n          color: var(--AccentColor);\n          font-size: 1rem;\n          font-weight: 700;\n        }\n      }\n      .AddPayWallet {\n        width: 16.5rem;\n        height: 10rem;\n        margin-left: 0.5rem;\n        border: 0.0625rem solid var(--Stroke);\n        border-radius: 0.625rem;\n        padding: 0.625rem;\n        display: flex;\n        cursor: pointer;\n        // justify-content: center;\n        align-items: center;\n        flex-direction: column;\n        gap: 1.25rem;\n        .WalletPayAmt {\n          color: var(--TextColor);\n          font-size: 1rem;\n          font-weight: 600;\n        }\n        .PayViaWallet {\n          color: var(--AccentColor);\n          font-size: 1rem;\n          font-weight: 700;\n        }\n      }\n      .PaymentLoading{\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background: #00000010;\n        backdrop-filter: blur(3px);\n      }\n      // flex-direction: column;\n\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
